import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectBusinessAreaList = createSelector(
  [
    (store: RootState) => store.userProfileLocation.locations,
    (store: RootState) => store.utils.category,
  ],
  (locations, categories) => {
    const categoryBusinessArea= categories.find(
      (category) => category.name === "Area de negocio" && category.module === "location"
    );

    return locations?.filter((location) => location.category?.id === categoryBusinessArea?.id) || [];
  }
);